<script>
  export default {
    functional: true,

    name: 'UiCardTitle',

    props: {
      large: Boolean,
    },

    render (h, {data, children, props, parent} ) {
      const staticClass = 'card-title';
      data.staticClass = data.staticClass ? `${data.staticClass} ${staticClass}` : staticClass

      return h('h1', {
        ...data
      }, children)
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/UiCardTitle.vue